import { CheckSquare } from "lucide-react";
import { useTranslate } from "ra-core";
import { Card } from "@/components/ui/card";

import { AllTasksLink } from "../marketing/AllTasks";
import { AddTask } from "../tasks/AddTask";
import { TasksListContent } from "../tasks/TasksListContent";

export const TasksList = () => {
  const translate = useTranslate();
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center">
        <div className="mr-3 flex">
          <CheckSquare className="text-muted-foreground w-6 h-6" />
        </div>
        <h2 className="text-xl font-semibold text-muted-foreground flex-1">
          {translate("crm.dashboard.upcoming_tasks", {
            _: "Upcoming Tasks",
          })}
        </h2>
        <AddTask display="icon" selectContact />
      </div>
      <Card className="p-4 mb-2 flex flex-col gap-3">
        <TasksListContent />
        {/*
          Barrel Scout injection: the ONLY desktop way into the task queue.
          This header hardcodes its four top-level tabs, so a <Resource> list
          alone is a route nobody can open -- which has already happened once
          in this fork, invisibly, for a whole session. Guarded by
          marketing/check-injections.mjs.

          Here rather than in the header because this card already says
          "Upcoming", which is the word that raises the question the link
          answers: what about the ones that are not upcoming any more.
        */}
        <AllTasksLink />
      </Card>
    </div>
  );
};
